module.exports = __webpack_public_path__ + "media/images/level_introduction1_sp-d0235ec4472960385d9a0d6ddf726d1b.png";